/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "protos.ai.v1";

export enum AiProviderType {
  UNSPECIFIED = "AI_PROVIDER_TYPE_UNSPECIFIED",
  OPENAI_SEMGREP_API_KEY = "AI_PROVIDER_TYPE_OPENAI_SEMGREP_API_KEY",
  OPENAI_CUSTOM_API_KEY = "AI_PROVIDER_TYPE_OPENAI_CUSTOM_API_KEY",
  OPENAI_AZURE = "AI_PROVIDER_TYPE_OPENAI_AZURE",
  AWS_BEDROCK = "AI_PROVIDER_TYPE_AWS_BEDROCK",
  GOOGLE_GEMINI = "AI_PROVIDER_TYPE_GOOGLE_GEMINI",
}

export function aiProviderTypeFromJSON(object: any): AiProviderType {
  switch (object) {
    case 0:
    case "AI_PROVIDER_TYPE_UNSPECIFIED":
      return AiProviderType.UNSPECIFIED;
    case 10:
    case "AI_PROVIDER_TYPE_OPENAI_SEMGREP_API_KEY":
      return AiProviderType.OPENAI_SEMGREP_API_KEY;
    case 11:
    case "AI_PROVIDER_TYPE_OPENAI_CUSTOM_API_KEY":
      return AiProviderType.OPENAI_CUSTOM_API_KEY;
    case 12:
    case "AI_PROVIDER_TYPE_OPENAI_AZURE":
      return AiProviderType.OPENAI_AZURE;
    case 20:
    case "AI_PROVIDER_TYPE_AWS_BEDROCK":
      return AiProviderType.AWS_BEDROCK;
    case 30:
    case "AI_PROVIDER_TYPE_GOOGLE_GEMINI":
      return AiProviderType.GOOGLE_GEMINI;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum AiProviderType");
  }
}

export function aiProviderTypeToJSON(object: AiProviderType): string {
  switch (object) {
    case AiProviderType.UNSPECIFIED:
      return "AI_PROVIDER_TYPE_UNSPECIFIED";
    case AiProviderType.OPENAI_SEMGREP_API_KEY:
      return "AI_PROVIDER_TYPE_OPENAI_SEMGREP_API_KEY";
    case AiProviderType.OPENAI_CUSTOM_API_KEY:
      return "AI_PROVIDER_TYPE_OPENAI_CUSTOM_API_KEY";
    case AiProviderType.OPENAI_AZURE:
      return "AI_PROVIDER_TYPE_OPENAI_AZURE";
    case AiProviderType.AWS_BEDROCK:
      return "AI_PROVIDER_TYPE_AWS_BEDROCK";
    case AiProviderType.GOOGLE_GEMINI:
      return "AI_PROVIDER_TYPE_GOOGLE_GEMINI";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum AiProviderType");
  }
}

export function aiProviderTypeToNumber(object: AiProviderType): number {
  switch (object) {
    case AiProviderType.UNSPECIFIED:
      return 0;
    case AiProviderType.OPENAI_SEMGREP_API_KEY:
      return 10;
    case AiProviderType.OPENAI_CUSTOM_API_KEY:
      return 11;
    case AiProviderType.OPENAI_AZURE:
      return 12;
    case AiProviderType.AWS_BEDROCK:
      return 20;
    case AiProviderType.GOOGLE_GEMINI:
      return 30;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum AiProviderType");
  }
}

export interface PutAiProviderRequest {
  providerType: AiProviderType;
  apiKey: string;
  endpoint?: string | undefined;
}

export interface GetAiProviderDataResponse {
  endpoint: string;
}

function createBasePutAiProviderRequest(): PutAiProviderRequest {
  return { providerType: AiProviderType.UNSPECIFIED, apiKey: "", endpoint: undefined };
}

export const PutAiProviderRequest = {
  encode(message: PutAiProviderRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.providerType !== AiProviderType.UNSPECIFIED) {
      writer.uint32(8).int32(aiProviderTypeToNumber(message.providerType));
    }
    if (message.apiKey !== "") {
      writer.uint32(18).string(message.apiKey);
    }
    if (message.endpoint !== undefined) {
      writer.uint32(26).string(message.endpoint);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PutAiProviderRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePutAiProviderRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.providerType = aiProviderTypeFromJSON(reader.int32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.apiKey = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.endpoint = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PutAiProviderRequest {
    return {
      providerType: isSet(object.providerType)
        ? aiProviderTypeFromJSON(object.providerType)
        : AiProviderType.UNSPECIFIED,
      apiKey: isSet(object.apiKey) ? String(object.apiKey) : "",
      endpoint: isSet(object.endpoint) ? String(object.endpoint) : undefined,
    };
  },

  toJSON(message: PutAiProviderRequest): unknown {
    const obj: any = {};
    if (message.providerType !== AiProviderType.UNSPECIFIED) {
      obj.providerType = aiProviderTypeToJSON(message.providerType);
    }
    if (message.apiKey !== "") {
      obj.apiKey = message.apiKey;
    }
    if (message.endpoint !== undefined) {
      obj.endpoint = message.endpoint;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PutAiProviderRequest>, I>>(base?: I): PutAiProviderRequest {
    return PutAiProviderRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PutAiProviderRequest>, I>>(object: I): PutAiProviderRequest {
    const message = createBasePutAiProviderRequest();
    message.providerType = object.providerType ?? AiProviderType.UNSPECIFIED;
    message.apiKey = object.apiKey ?? "";
    message.endpoint = object.endpoint ?? undefined;
    return message;
  },
};

function createBaseGetAiProviderDataResponse(): GetAiProviderDataResponse {
  return { endpoint: "" };
}

export const GetAiProviderDataResponse = {
  encode(message: GetAiProviderDataResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.endpoint !== "") {
      writer.uint32(18).string(message.endpoint);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetAiProviderDataResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAiProviderDataResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.endpoint = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAiProviderDataResponse {
    return { endpoint: isSet(object.endpoint) ? String(object.endpoint) : "" };
  },

  toJSON(message: GetAiProviderDataResponse): unknown {
    const obj: any = {};
    if (message.endpoint !== "") {
      obj.endpoint = message.endpoint;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAiProviderDataResponse>, I>>(base?: I): GetAiProviderDataResponse {
    return GetAiProviderDataResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAiProviderDataResponse>, I>>(object: I): GetAiProviderDataResponse {
    const message = createBaseGetAiProviderDataResponse();
    message.endpoint = object.endpoint ?? "";
    return message;
  },
};

declare const self: any | undefined;
declare const window: any | undefined;
declare const global: any | undefined;
const tsProtoGlobalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
